<template>
  <img
    v-if="!hidden && resolvedUrl"
    v-bind="$attrs"
    :src="resolvedUrl"
    :alt="alt"
    :aria-hidden="decorative ? 'true' : null"
    @load="$emit('load', $event)"
    @error="handleError"
  >
</template>

<script>
export default {
  name: "AvatarFrameMedia",
  inheritAttrs: false,
  props: {
    animationUrl: { type: String, default: "" },
    previewUrl: { type: String, default: "" },
    alt: { type: String, default: "" },
    decorative: { type: Boolean, default: true },
    play: { type: Boolean, default: true }
  },
  data() {
    return { reducedMotion: false, forcePreview: false, hidden: false, mediaQuery: null }
  },
  computed: {
    resolvedUrl() {
      const shouldPreview = this.reducedMotion || this.forcePreview || !this.play
      return shouldPreview ? (this.previewUrl || this.animationUrl) : (this.animationUrl || this.previewUrl)
    }
  },
  watch: {
    animationUrl() { this.resetFailure() },
    previewUrl() { this.resetFailure() }
  },
  mounted() {
    if (!window.matchMedia) return
    this.mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)")
    this.reducedMotion = this.mediaQuery.matches
    if (this.mediaQuery.addEventListener) this.mediaQuery.addEventListener("change", this.handleMotionChange)
    else if (this.mediaQuery.addListener) this.mediaQuery.addListener(this.handleMotionChange)
  },
  beforeDestroy() {
    if (!this.mediaQuery) return
    if (this.mediaQuery.removeEventListener) this.mediaQuery.removeEventListener("change", this.handleMotionChange)
    else if (this.mediaQuery.removeListener) this.mediaQuery.removeListener(this.handleMotionChange)
  },
  methods: {
    handleMotionChange(event) {
      this.reducedMotion = Boolean(event.matches)
    },
    resetFailure() {
      this.forcePreview = false
      this.hidden = false
    },
    handleError(event) {
      if (!this.forcePreview && this.previewUrl && this.resolvedUrl !== this.previewUrl) {
        this.forcePreview = true
        return
      }
      this.hidden = true
      this.$emit("error", event)
    }
  }
}
</script>
